import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Studio } from 'src/app/models/studio';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditStudioComponent extends BaseEditForm implements OnInit {

  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditStudioComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Studio,) {
    super();
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.data?.nome, Validators.required],
      via: [this.data?.via],
      civico: [this.data?.civico],
      comune: [this.data?.comune],
      tel: [this.data?.tel],
      fax: [this.data?.fax],
      cell: [this.data?.cell],
      email: [this.data?.email],
      firmatario: [this.data?.firmatario],
      detrazione_accertamento_su_incaricato: [this.data?.detrazione_accertamento_su_incaricato !== false]
    });
  }

}

